export { getWebExperimentCookie as getOptimizelyUserId } from 'utils/web-experiment';
export const IMMEDIATE_FEATURES = {
    AIRPORT_CHECKOUT_V2: 'airport_checkout_v2',
    AIRPORT_INSURANCE_UPSELL: 'airport_insurance_upsell',
    ACQUISITION_MOBILE_WEB_SEARCH_REVAMP: 'acquisition_mobile_web_search_revamp',
    VIEW_RATINGS_FILTER: 'view_ratings_filter',
    EXPRESS_CHECKOUT_WEB: 'express_checkout_web',
    USE_NEW_GOOGLE_PLACES_API: 'use_new_google_places_api',
};
